module.exports = __webpack_public_path__ + "static/audio-transparent-45be75ae3dc366bc9b51a776a3e4fc2f.png";